import { Box, Button, Skeleton, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { useCareMatrix } from 'hooks/useCareMatrix';
import { EndUserState, getCareMatrixModuleUserData } from 'services/user';

import * as S from './styles';

export function Criticality() {
  const intl = useIntl();
  const { patientCognitoId } = useCareMatrix();

  const {
    data: user,
    isLoading,
    isError,
  } = useQuery<EndUserState>({
    queryKey: ['getCareMatrixModuleUserData', patientCognitoId],
    queryFn: () => getCareMatrixModuleUserData(patientCognitoId),
  });

  const userHasCriticalitySigns = user?.criticality?.has_shown_critical_signs;

  const userCriticalityIsConfirmed =
    user?.criticality?.is_criticality_confirmed;

  return (
    <Box>
      {!isError ? (
        <S.Wrapper>
          <Typography variant="h6">
            {intl.formatMessage({ id: 'ENDUSER.SESSION.CRITICAL.TITLE' })}
          </Typography>

          {isLoading && (
            <Box
              mt={0.5}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Skeleton variant="rectangular" width="208px" height="20px" />
              <Skeleton variant="rounded" width={105} height={30} />
            </Box>
          )}

          {!isLoading && (
            <Box
              mt={0.5}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="flex-start" gap={0.5}>
                {userHasCriticalitySigns ? (
                  <>
                    <S.CriticalityIcon />
                    <Typography
                      variant="body2"
                      color="error"
                      width="fit-content"
                    >
                      {intl.formatMessage({
                        id: 'CAREMATRIXCPTC.CRITICALSTATUS.TRUE',
                      })}
                    </Typography>
                  </>
                ) : (
                  <>
                    <S.NoCriticalityIcon />
                    <Typography variant="body2" color="text.secondary">
                      {intl.formatMessage({
                        id: 'CAREMATRIXCPTC.CRITICALSTATUS.FALSE',
                      })}
                    </Typography>
                  </>
                )}
              </Box>

              <Button
                variant="contained"
                size="small"
                href={`enduser/${user?.cognitoID}`}
                target="_blank"
                sx={{ minWidth: 'fit-content' }}
              >
                {userCriticalityIsConfirmed
                  ? intl.formatMessage({
                      id: 'CAREMATRIXCPTC.BUTTONCRITICALITY.DETAILS',
                    })
                  : intl.formatMessage({
                      id: 'CAREMATRIXCPTC.BUTTONCRITICALITY.NOTVALIDATE',
                    })}
              </Button>
            </Box>
          )}
        </S.Wrapper>
      ) : (
        <Box />
      )}
    </Box>
  );
}
